import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

interface AlertCircleProps extends SvgProps {
  glyphColor?: Colors | string;
}

export const AlertCircle = ({
  size = 16,
  color = Colors.black,
  glyphColor = Colors.white,
  className,
}: AlertCircleProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" fill="currentColor" r="7" />
      <path
        d="M8 4.5V8.5"
        stroke={glyphColor}
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <circle cx="8" cy="11.25" fill={glyphColor} r="0.85" />
    </svg>
  </SvgIcon>
);
